/** @format */

import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader";
import CashierNav from "./VerticalWizardNav";
import { Btn } from "../../../AbstractElements";
import http from "../../../services/http";
import { getAPIURL, getVendorID } from "../../../services/helper";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Loader from "../../../Layout/Loader";
import {
  addNewCashier,
  setLoading,
  updateCashier,
} from "../../../ReduxToolkit/Reducers/AppReducer";
import { useNavigate, useParams } from "react-router-dom";
import PermissionsForm from "./PermissionsForm";
import CashierInfo from "./CashierInfo";
import { CashierFormData } from "../../../Types/Forms.type";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";

export default function CashierForm({ cashier_id }: { cashier_id: any }) {
  const [formData, setFormData] = useState<CashierFormData>({
    full_name: "",
    password: "",
    pos_code: "",
    role: "",
    phone_number: "",
    address: "",
    city: "",
    email: "",
    permissions: {}, // ✅ now it's an object
  });
  const [steps, setSteps] = useState(1);
  const [showFinish, setShowFinish] = useState(false);
  const activeCallBack = useCallback((tab: number) => {
    setSteps(tab);
  }, []);
  const { isLoading, vendorCashiers } = useSelector((state: any) => state.app);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (cashier_id) {
      const found = vendorCashiers.find(
        (c: any) => c.id === parseInt(cashier_id)
      );
      // console.log(found);
      if (found) {
        setFormData((existing: any) => ({
          ...existing,
          ...found,
          full_name: `${found.first_name} ${found.last_name}`,
        }));
      }
    }
  }, [cashier_id, vendorCashiers, setFormData]);

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, type, value, checked } = event.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        permissions: {
          ...prev.permissions,
          [name]: checked,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAddNew = async () => {
    try {
      const api_url = getAPIURL();
      const vendor_id = getVendorID();

      dispatch(setLoading(true));
      // return console.log(formData);
      const { full_name, email, password, pos_code, role } = formData;
      if (
        full_name !== "" &&
        email !== "" &&
        password !== "" &&
        role !== "" &&
        pos_code !== ""
      ) {
        const payload = { ...formData, vendor_id };
        const { data: cashier } = await http.post(
          `${api_url}/cashiers`,
          payload
        );
        if (!cashier.success) return toast.error(cashier.data);

        toast.success("Cashier Saved");
        if (cashier_id) {
          dispatch(updateCashier(cashier.data));
        } else {
          dispatch(addNewCashier(cashier.data));
        }
        navigate("/cashiers");
      } else {
        return toast.error(
          "please fill out all the fields before moving on to the next step"
        );
      }
    } catch (e: any) {
      toast.error(e.message);
    }
  };

  return (
    <Col md={12}>
      {isLoading && <Loader />}
      <Card className="title-line">
        <CardHeader>
          <Button
            color="success"
            onClick={() => dispatch(openView("cashiers"))}
          >
            All Cashiers
          </Button>
        </CardHeader>
        <CardBody>
          <div className="vertical-main-wizard">
            <Row className="g-3">
              <Col xxl={3} xl={4} xs={12}>
                <CashierNav steps={steps} activeCallBack={activeCallBack} />
              </Col>
              <Col xxl={9} xl={8} xs={12}>
                <TabContent activeTab={steps}>
                  <TabPane tabId={1}>
                    <CashierInfo
                      formData={formData}
                      updateFormData={updateFormData}
                    />
                  </TabPane>
                  <TabPane tabId={2}>
                    <PermissionsForm
                      formData={formData}
                      updateFormData={updateFormData}
                    />
                  </TabPane>
                </TabContent>
                <Col xs={12} className="text-start m-t-10">
                  {steps === 1 ? (
                    <Btn
                      color={showFinish ? "success" : "primary"}
                      onClick={() => setSteps(2)}
                    >
                      Next: Permissions
                    </Btn>
                  ) : (
                    <Btn
                      color={showFinish ? "success" : "primary"}
                      onClick={handleAddNew}
                    >
                      Save
                    </Btn>
                  )}
                </Col>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
